import { TableConfig } from '@shared/interfaces/table/table-config';
import { ChildMeteringPoint } from '@app/api/dmc';
import { meteringPointIdPartial } from '@shared/columns/meteringpoint.columns';
import { Columns } from '@shared/interfaces/table/column-config';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';

export const meteringPointChildTableConfig: TableConfig<ChildMeteringPoint> = {
  id: 'meteringpoint-details-child',
  columns: [
    meteringPointIdPartial as Columns<ChildMeteringPoint>,
    meteringPointTypePartial,
    {
      title: 'meteringpoint.table.gridArea',
      key: 'gridAreaName'
    },
    settlementmethodPartial,
  ]
};
